import { render, staticRenderFns } from "./HousingStatTab.vue?vue&type=template&id=1caf6179"
import script from "./HousingStatTab.vue?vue&type=script&lang=js"
export * from "./HousingStatTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports